import TextField from "@material-ui/core/TextField";

type Props = {
	value: string | null;
	onChange: (value: string) => void;
};

export const SearchFilter = ({ value, onChange }: Props) => {
	const handleFilter = (e: any) => {
		onChange(e.target.value);
	};

	return (
		<div style={{ position: "relative", marginTop: 4 }}>
			<TextField
				style={{ borderTopLeftRadius: 3, borderTopRightRadius: 3 }}
				label="Search"
				variant="outlined"
				margin="dense"
				value={value}
				onChange={handleFilter}
				fullWidth
				autoComplete="off"
			/>
		</div>
	);
};
